"use client";

import React from "react";
import Image from "next/image";

const stats = [
  { icon: "/images/Projects Delivered.png", value: "300+", label: "Projects Delivered" },
  { icon: "/images/Team Members.png", value: "100+", label: "Happy Clients" },
  { icon: "/images/RepeatAndReferral.png", value: "50+", label: "Repeat & Referral" },
  { icon: "/images/Profile.png", value: "10+", label: "Successful Years" },
  { icon: "/images/Countries Served.png", value: "10+", label: "Countries Served" },
];

export default function NewAboutSection() {
  return (
    <section className="w-full px-3 sm:px-4 lg:px-6 my-6! bg-background-secondary">
      <div className="flex flex-col lg:flex-row gap-3">
        <div className="flex flex-col xl:flex-row w-full overflow-hidden rounded-2xl  border border-border-primary  lg:w-[70%]">
          <div className="w-full xl:flex-[1.1] bg-background-secondary p-5! sm:p-7! md:p-8! lg:p-10! flex flex-col justify-between">
            <div>
              <p className="flex items-center gap-3 text-[11px] sm:text-sm font-semibold tracking-[3px] uppercase mb-3!">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">WHO WE ARE</span>

                <span className="h-px w-16 bg-gradient-to-r from-cyan-400 to-purple-600" />
              </p>

              <h2 className="text-text-primary text-2xl sm:text-3xl md:text-4xl  font-bold leading-tight mb-4!">About Tycho</h2>

              <p className="text-text-secondary text-sm sm:text-base lg:text-[17px] leading-relaxed max-w-xl">
                Delivering innovative web, mobile, and digital solutions that help businesses achieve scalable growth, better performance, and long-term digital success worldwide.
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 sm:gap-2 mt-8! lg:mt-10!">
              {stats.map((stat, i) => (
                <div key={i} className="flex flex-col items-center text-center group">
                  <div className="mb-2! ">
                    <img src={stat.icon} alt={stat.label} />
                  </div>

                  <div className="text-text-primary  text-lg font-bold mb-1!">{stat.value}</div>

                  <div className="text-text-secondary  text-[11px] sm:text-xs  font-medium leading-tight">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative w-full xl:w-[420px] 2xl:w-[480px] min-h-[260px] sm:min-h-[350px] md:min-h-[420px] xl:min-h-full ">
            <Image src="/images/tycho_building.webp" alt="Tycho Technologies Building" fill priority className="object-cover xl:rounded-none " />
          </div>
        </div>

        <div className="bg-cta-gradient rounded-2xl p-5! sm:p-7! md:p-8! lg:p-10! flex flex-col justify-center w-full lg:w-[30%] ">
          <div className="max-w-3xl ">
            <h3 className="text-white text-2xl sm:text-3xl  font-semibold leading-tight mb-5!">Ready to elevate your digital presence with innovative technology solutions?</h3>

            <p className="text-blue-100 text-sm sm:text-base lg:text-md leading-relaxed mb-8!">
              Our team is ready to help you build scalable, high-performance digital experiences tailored to your business goals.
            </p>

            <a
              href="contact-us"
              target="_self"
              rel="noopener noreferrer"
              className="inline-flex w-full sm:w-auto items-center justify-center gap-3 bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/30 text-white font-semibold text-sm sm:text-base px-6! py-3! rounded-xl transition-all duration-300 hover:scale-105 active:scale-95"
            >
              Let&apos;s Build Something Great
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
